import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanCreateProvider = (): boolean => {
  const [canCreateProvider, setCanCreateProvider] =
    React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const createAllPermission: Permission = {
    resource: 'providers',
    action: 'createbasic',
    scope: 'all',
  };

  const canCreateAll = useHasPermission(user, createAllPermission);

  React.useEffect(() => {
    setCanCreateProvider(canCreateAll);
  }, [canCreateAll]);

  return canCreateProvider;
};
